<template>
  <div
    class="absolute bg-primary text-app-color bottom-56 z-10 md:rounded-4 w-full md:max-w-380 h-380 md:h-280 py-15 pl-16 pr-4"
    :class="isDarkMode ? 'shadow-search' : 'shadow-dropdown'"
  >
    <div class="flex pr-12">
      <!-- S E A R C H -->
      <div
        class="flex items-center mb-12 px-10 rounded-4 w-full"
        :class="isDarkMode ? 'bg-hover' : 'bg-grey-400'"
      >
        <i
          class="icon-search cursor-pointer opacity-50 hover:opacity-100 anim-opacity"
          :class="{'opacity-100': isFocused}"
          @click="toggleInput"
        />
        <input
          ref="inputRef"
          v-model="searchValue"
          type="text"
          placeholder="search"
          class="w-full text-14 bg-transparent pr-10 pl-10 py-6 focus:outline-none
            placeholder-app-color opacity-50 focus:opacity-100 anim-opacity"
          @focus="isFocused = true"
          @blur="isFocused = false"
          @click="toggleInput"
          @input="searchGif"
        >
      </div>
    </div>
    <!-- G I F S -->
    <div class="overflow-y-auto overflow-x-hidden max-h-305 md:max-h-205 min-h-60">
      <div class="gap-x-8 pr-4 list-gifs">
        <img
          v-for="giphy in giphies"
          :key="giphy.id"
          :src="giphy.images.original.url"
          class="mb-8 w-full cursor-pointer rounded-8"
          @click="selectGif(giphy)"
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { computed, defineComponent, ref, onMounted } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  emits: ['selectGif'],

  setup (_, { emit }) {
    const { getters, commit } = useStore()

    const BASE_URL = 'https://api.giphy.com/v1/gifs'
    const API_KEY = 'iEiO0Ibusegthc8RhkMQoIZKlrUx2POk'
    const LIMIT = 34
    let ATTEMPTS = 5

    let debounce = null
    const giphies = ref([])
    const searchValue = ref('')
    const isFocused = ref(false)
    const inputRef = ref(null)

    const isDarkMode = computed(() => getters.isDarkMode)

    const searchByKeywords = () => {
      ATTEMPTS = 5
      if (searchValue.value) {
        const OFFSET = Math.floor(Math.random() * 4998) + 1

        getGifs(OFFSET)
      }
    }

    function getGifs (offset) {
      const link = `${BASE_URL}/search?q=${searchValue.value}&api_key=${API_KEY}&limit=${LIMIT}&offset=${offset}`

      axios.get(link)
        .then(res => {
          if (res.data.data.length > 20) {
            giphies.value = res.data.data
          } else {
            ATTEMPTS--
            const newOffset = res.data.pagination.total_count
            const OFFSET = Math.floor(Math.random() * newOffset)

            if (ATTEMPTS > 0) getGifs(OFFSET)
          }
        })
        .catch(err => {
          if (err) commit('setNotification', { isVisible: true, message: err, color: 'error' })
        })
    }

    const onLoad = () => {
      const link = `${BASE_URL}/trending?api_key=${API_KEY}&limit=${LIMIT}`

      axios.get(link)
        .then(res => (giphies.value = res.data.data))
        .catch((err) => {
          if (err) commit('setNotification', { isVisible: true, message: err, color: 'error' })
        })
    }

    function selectGif (gif) {
      emit('selectGif', gif.images.original.url)
    }

    function toggleInput () {
      inputRef.value.focus()
    }

    function searchGif () {
      clearTimeout(debounce)
      debounce = setTimeout(() => {
        searchByKeywords()
      }, 600)
    }

    onMounted(() => {
      onLoad()
    })

    return {
      // ref
      searchValue,
      isFocused,
      inputRef,
      giphies,
      // computed
      isDarkMode,
      // function
      selectGif,
      toggleInput,
      searchGif
    }
  }
})
</script>

<style scoped>
.list-gifs {
  column-count: 2
}
</style>
